import { get, set, isFinite } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Expenses, Expense } from '@funnels/types';

import { INITIAL_EXPENSES } from './initialFormValues';
import formatToPrecision from './formatToPrecision';

export default function divideGroupedExpenses(expenses: Expenses[]): Expenses[] {
  return expenses.reduce((acc: Expenses[], expenses: Expenses): Expenses[] => {
    const groupedApplicantId = get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_GROUPED_APPLICANT_ID(0));
    if (!groupedApplicantId) {
      return [...acc, expenses];
    }
    const applicantId = get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_APPLICANT_ID(0));
    const divideExpenses = get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_EXPENSES(0)).map(
      (e: Expense, expenseIndex: number) => {
        const groupAmount = get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_EXPENSE_AMOUNT(0, expenseIndex));
        const amount = isFinite(groupAmount) ? formatToPrecision(groupAmount / 2, 2) : groupAmount;
        return { ...e, amount };
      }
    );

    const expenses1: Expenses = INITIAL_EXPENSES();
    set({ expenses: [expenses1] }, FIELD_PATHS.EXPENSES_CLIENT_ID(0), applicantId);
    set({ expenses: [expenses1] }, FIELD_PATHS.EXPENSES_APPLICANT_ID(0), applicantId);
    set({ expenses: [expenses1] }, FIELD_PATHS.EXPENSES_EXPENSES(0), divideExpenses);

    const expenses2: Expenses = INITIAL_EXPENSES();
    set({ expenses: [expenses2] }, FIELD_PATHS.EXPENSES_CLIENT_ID(0), groupedApplicantId);
    set({ expenses: [expenses2] }, FIELD_PATHS.EXPENSES_APPLICANT_ID(0), groupedApplicantId);
    set({ expenses: [expenses2] }, FIELD_PATHS.EXPENSES_EXPENSES(0), divideExpenses);

    return [...acc, expenses1, expenses2];
  }, []);
}
